/**
 * Définition des en-têtes de colonnes pour la table Handsontable
 * Ces labels correspondent aux colonnes affichées dans l'interface de gestion des musiques
 * L'index de chaque élément (0-based) est utilisé pour identifier les colonnes cachées
 */
export const COL_HEADERS = [
  'Mix',           // 0
  'Cover',         // 1
  'Titre',         // 2
  'Artiste',       // 3
  'Album',         // 4
  'Version',       // 5
  'Année',         // 6
  'Date sortie',   // 7
  'Instagram',     // 8
  'Voix',          // 9
  'Pays',          // 10
  'Langue',        // 11
  'Stations',      // 12
  'Propriétés',    // 13
  'Diffusion',     // 14
  'Genre 1',       // 15
  'Genre 2',       // 16
  'Genre 3',       // 17
  'Mood 1',        // 18
  'Mood 3',        // 19
  'Tempo 1',       // 20
  'Label',         // 21
  'BPM',           // 22
  'Photo artiste', // 23
  'DJ'             // 24
];

/**
 * Interface pour représenter une colonne avec son index et son label
 */
export interface ColumnHeader {
  index: number;
  label: string;
}

/**
 * Retourne la liste des colonnes avec leurs index
 */
export function getColumnsWithIndex(): ColumnHeader[] {
  return COL_HEADERS.map((label, index) => ({ index, label }));
}

